import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var FactSheet = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment factsheet on FactSheet {\n    displayName\n    slug\n    elements {\n      slug\n      keyName\n      elements {\n        slug\n        keyName\n        isHtml\n        value\n      }\n    }\n  }\n"])));
export default FactSheet;